import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import moment from "moment";
import { APIHeaders, BASEURL } from "../config";
import { isWWWhostname } from "../utils/helpers";
import { apiURL } from "../utils/axios";

const credentials = {
  callerid: window.localStorage.getItem("spiral_username"),
  sessionid: window.localStorage.getItem("spiral_token"),
};

export const customerClassAPI = createApi({
  reducerPath: "customerclassPath",
  baseQuery: fetchBaseQuery({
    baseUrl:
      isWWWhostname() === "xyz" ? apiURL.mmsUrlStaging : apiURL.mmsUrlDev,
    headers: APIHeaders,
    prepareHeaders: (headers, {}) => {
      //   const token = credentials.token;
      //   if (token) {
      //     headers.set("Version", `0.1`);
      //     return headers;
      //   }
    },
  }),
  endpoints: (build) => ({
    // create customer class
    createCustomerClass: build.mutation({
      query: (data) => ({
        url: "settings/customerclass/createcustomerclass",
        method: "POST",
        body: {
          ...credentials,
          ...data, // Includes siteid, customerclass, customertype, timeofuse, createdby
        },
      }),
    }),
    // get customer sites
    getCustomerClassInSite: build.mutation({
      query: (data) => ({
        url: "settings/customerclass/getallcustomerclassesforsite",
        method: "POST",
        body: {
          ...credentials,
          siteid: Number(data),
        },
      }),
    }),
    getOthersiteCustomerClass: build.mutation({
      query: (data) => ({
        url: "settings/customerclass/getallcustomerclassesforallsites",
        method: "POST",
        body: {
          ...credentials,
        },
      }),
    }),
    getCustomerClassByType: build.mutation({
      query: (data) => ({
        url: "settings/customerclass/getcustomerclassbytype",
        method: "POST",
        body: {
          ...credentials,
          ...data, // Includes siteid, customertype
        },
      }),
    }),
    getCustomerClassInfo: build.mutation({
      query: (data) => ({
        url: "settings/customerclass/getcustomerclassinfo",
        method: "POST",
        body: {
          ...credentials,
          ...data, // Includes siteid, customerclassortype
        },
      }),
    }),
    getCustomerTypeByClass: build.mutation({
      query: (data) => ({
        url: "settings/customerclass/getcustomertypebyclass",
        method: "POST",
        body: {
          ...credentials,
          ...data, // Includes siteid, customerclass
        },
      }),
    }),
  }),
});

export const {
  useCreateCustomerClassMutation,
  useGetCustomerClassInSiteMutation,
  useGetOthersiteCustomerClassMutation,
  useGetCustomerClassByTypeMutation,
  useGetCustomerClassInfoMutation,
  useGetCustomerTypeByClassMutation,
} = customerClassAPI;
